export const emptyStateSubtitleStyle = {
  lineHeight: "24px",
};
